import React from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import { FaRegClock, FaUserGraduate, FaStar, FaRegHeart } from "react-icons/fa";

const CourseSection = () => {
    const courses = [
        {
            id: 1,
            weeks: "12 Weeks",
            level: "Beginner",
            title: "The Complete Package Of Digital Marketing Courses",
            instructor: "James Willam",
            rating: 5,
            price: "$180.00",
            oldPrice: "$240.00",
            lessons: "10 lessons",
            students: "200 students",
            img: "about-img.jpg", // replace with your image URL
        },
        {
            id: 2,
            weeks: "10 Weeks",
            level: "Expert",
            title: "Top Marketing Strategy Courses - 15 Courses In 1",
            instructor: "2D Course",
            rating: 4,
            price: "$180.00",
            oldPrice: "$240.00",
            lessons: "10 lessons",
            students: "200 students",
            img: "about-img1.jpg",
        },
        {
            id: 3,
            weeks: "15 Weeks",
            level: "All Level",
            title: "Digital Marketing Masterclass - Complete Guide",
            instructor: "Wokka Stary",
            rating: 5,
            price: "$180.00",
            oldPrice: "$240.00",
            lessons: "10 lessons",
            students: "200 students",
            img: "about-img2.jpg",
        },
        {
            id: 4,
            weeks: "15 Weeks",
            level: "All Level",
            title: "Digital Marketing Masterclass - Complete Guide",
            instructor: "Wokka Stary",
            rating: 5,
            price: "$180.00",
            oldPrice: "$240.00",
            lessons: "10 lessons",
            students: "200 students",
            img: "about-img2.jpg",
        },
        {
            id: 5,
            weeks: "15 Weeks",
            level: "All Level",
            title: "Digital Marketing Masterclass - Complete Guide",
            instructor: "Wokka Stary",
            rating: 5,
            price: "$180.00",
            oldPrice: "$240.00",
            lessons: "10 lessons",
            students: "200 students",
            img: "about-img2.jpg",
        },
        {
            id: 6,
            weeks: "15 Weeks",
            level: "All Level",
            title: "Digital Marketing Masterclass - Complete Guide",
            instructor: "Wokka Stary",
            rating: 5,
            price: "$180.00",
            oldPrice: "$240.00",
            lessons: "10 lessons",
            students: "200 students",
            img: "about-img2.jpg",
        },
    ];

    return (
        <Container className="py-5">
            <Row className="mb-4">
                <Col>
                    <p className="text-muted">Showing 1-9 of 55 results</p>
                </Col>
                <Col className="text-end">
                    <p className="text-muted">Default sorting ▼</p>
                </Col>
            </Row>

            <Row>
                {courses.map((course) => (
                    <Col md={4} key={course.id} className="mb-4">
                        <Card className="border-0 shadow-sm rounded-3 h-100">
                            <div className="position-relative">
                                <Card.Img
                                    variant="top"
                                    src={course.img}
                                    className="rounded-top"
                                    style={{ height: "200px", objectFit: "cover" }}
                                />
                                <Badge
                                    bg="warning"
                                    className="position-absolute top-0 start-0 m-2 fw-semibold"
                                >
                                    {course.weeks}
                                </Badge>
                            </div>
                            <Card.Body>
                                <Badge bg="light" text="dark" className="mb-2 fw-semibold">
                                    {course.level}
                                </Badge>
                                <Card.Title className="fw-bold" style={{ fontSize: "1rem" }}>
                                    {course.title}
                                </Card.Title>
                                <p className="mb-1 text-muted small">{course.instructor}</p>
                                <div className="text-warning mb-2">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar
                                            key={i}
                                            className={i < course.rating ? "" : "text-secondary"}
                                        />
                                    ))}
                                </div>
                                <div className="mb-2">
                                    <span className="fw-bold text-dark">{course.price}</span>{" "}
                                    <del className="text-muted">{course.oldPrice}</del>
                                </div>
                                <div className="d-flex align-items-center justify-content-between text-muted small mb-3">
                                    <span>
                                        <FaRegClock className="me-1" /> {course.lessons}
                                    </span>
                                    <span>
                                        <FaUserGraduate className="me-1" /> {course.students}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <Button
                                        variant="outline-dark"
                                        className="rounded-pill fw-semibold"
                                    >
                                        Enroll Now
                                    </Button>
                                    <Button
                                        variant="outline-dark"
                                        className="rounded-circle p-2"
                                        style={{ width: "40px", height: "40px" }}
                                    >
                                        <FaRegHeart />
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default CourseSection;
